import { styled, selectTheme, media } from '@creditas-ui/react';

const MenuBackground = styled.div`
  background: ${selectTheme('colors.neutral.0')};
  display: flex;
  width: 100%;
  height: 60px;
  z-index: 10;
  ${media.up('5xl')} {
    height: 80px;
  }
`;

const Nav = styled.nav`
  width: 100%;
  display: flex;
  max-width: 1440px;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${selectTheme('spacingRight.10xl')};
  box-sizing: border-box;
  left: 50%;
  transform: translateX(-50%);
  position: fixed;
  z-index: 10;
  ${media.up('5xl')} {
    height: 80px;
    padding: 0 ${selectTheme('spacingRight.18xl')} 0 ${selectTheme('spacingLeft.16xl')};
  }
`;

export { Nav, MenuBackground };
